// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__27JIC","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1ktPS","obliqueLine":"membershipbadge_obliqueLine__355_F"};